<div class="container-fluid bg-fondo p-5">
    <div class=" justify-content-center text-center">
        <p>En caso en que nos solicites anular el</p>
        <p>cupo, te pedimos que diligencies la</p>
        <p>siguiente información:</p>
    </div>
    <div class="row justify-content-center">
        <form [formGroup]="forma" (ngSubmit)="registrar()" class="mt-3 example-form">
            <div class="row justify-content-center">
                <div class="form-group col-12 col-sm-10" [ngClass]="{ 'text-danger': motivo.invalid && motivo.touched }">
                    <label class="col-form-label col-form-label-sm">Motivo desistimiento de adjudicación</label>
                    <ng-select
                      [items]="mdn"
                      bindValue="valueId"
                      bindLabel="name"
                      class="custom"
                      [virtualScroll]="true"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="Selecciona"
                      notFoundText="No hay coincidencias"
                      clearAllText="Limpiar todo"
                      formControlName="motivo">
                    </ng-select>
                    <div *ngIf="motivo.errors && (motivo.dirty || motivo.touched)">
                      <span *ngIf="motivo.errors.required">Requerido</span>
                    </div>
                  </div>
            </div>
            <div class="row justify-content-center">
                <div class="form-group col-12 col-sm-10" [ngClass]="{ 'text-danger': otro_motivo.invalid && otro_motivo.touched }">
                    <label class="col-form-label col-form-label-sm">¿Otro motivo?</label>
                    <input
                    type="text"
                    class="form-control"
                    [readonly]="motivo.value != '25'"
                    formControlName="otro_motivo"
                    [imask]="nameMask">
                    <div *ngIf="otro_motivo.errors && (otro_motivo.dirty || otro_motivo.touched)">
                        <span *ngIf="otro_motivo.errors.required">Requerido</span>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="form-group col-12 col-sm-10">
                    <label class="col-form-label col-form-label-sm">Observación <small class="op-text">(opcional)</small></label>
                        <textarea
                            class="form-control"
                            [readonly]="motivo.value != '25'"
                            formControlName="observacion"
                            [imask]="nameMask"
                            rows="5"
                            cols="20"
                        >
                        </textarea>
                 </div>
            </div>
            <div class="row justify-content-center">
                <button type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" [disabled]="formSubmitted" (click)="onBack()">
                    <i class="fas fa-arrow-left"></i>
                    Volver
                </button>
                <button type="submit" class="btn btn-primary font-weight-bold m-2" title="Enviar" [disabled]="formSubmitted">
                    <i class="fas fa-paper-plane"></i>
                    Enviar
                </button>
            </div>
        </form>
    </div>
    <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
        <p class='color-spinner-text'>Cargando... </p>
    </ngx-spinner>
</div>
